define('bizzabo/views/PushMsgsBoxView',[
    'jquery',
    'jquery-charcount',
    'backbone',
    'underscore',
    'bizzabo/models/Global',
    'bizzabo/bzapi',
    'bizzabo/utils',
    'bizzabo/consts',
    'bizzabo/views/popup/ConfirmDialogView',
    'hbars!bizzabo/templates/pushMsgsBox'
], function(
    $,
    jQueryCharCount,
    Backbone,
    _,
    Global,
    BZAPI,
    UTILS,
    Consts,
    ConfirmDialogView,
    template
    ) {

    var PushMsgsBoxView = Backbone.View.extend({

        events : {
            'click a.sendMessageButton' : 'sendMessage',
            'click .push-message-box-tab' : 'tabClicked',
            'change textarea' : 'messageChanged',
            'keyup textarea' : 'messageChanged'
        },

        MAX_MESSAGE_LENGTH : 250,

        initialize : function() {
            _.bindAll(this, 'sendMessageConfirmed');
            Backbone.on(Consts.Notifications.signin.SIGNED_IN, this.updateTextareaState, this);
            Backbone.on(Consts.Notifications.signin.SIGNED_OUT, this.updateTextareaState, this);
            this.model.on('change:status', this.updateTextareaState, this);
        },

        remove : function() {
            Backbone.off(Consts.Notifications.signin.SIGNED_IN, this.updateTextareaState, this);
            Backbone.off(Consts.Notifications.signin.SIGNED_OUT, this.updateTextareaState, this);
            this.model.off('change:status', this.updateTextareaState, this);
            this.off();
            this.$el.remove();
        },

        renderToolTips : function() {
            this.$('[data-toggle="tooltip"]').tooltip({
                placement : 'bottom'
            });
        },

        render : function() {
            var html = template(this.model.toJSON());
            this.$el.html(html);

            this.renderToolTips();
            this.updateButtonState();
            this.updateTextareaState();
            this.setCounter();
            return this;
        },

        // Message

        isMessageValid : function() {
            var message = this.$('textarea').val();
            return message && message.length > 0 && message.length <= this.MAX_MESSAGE_LENGTH;
        },

        canSendMessage : function() {
            return this.isMessageValid() && (this.model.canSendPushNotifications() == this.model.sendPushNotificationsStatus.Allowed);
        },

        messageChanged : function() {
            this.updateButtonState();
        },

        clearMessage : function() {
            this.$('textarea').val('');
            this.$('textarea').trigger('change');
        },

        sendMessage : function() {
            Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                category : 'Organizer Actions',
                action : 'push send clicked'
            });

            if (!this.isMessageValid() || (this.model.canSendPushNotifications() != this.model.sendPushNotificationsStatus.Allowed)) {
                return;
            }

            var message = this.$('textarea').val();
            new ConfirmDialogView({
                title : 'Send Announcement',
                html : '<p>The following announcement will be sent to your attendees:</p><p><strong>' + $('<div/>').text(message).html() + '</strong></p><p>Are you sure?</p>',
                confirm : 'Send',
                cancel : 'Cancel',
                onConfirm : this.sendMessageConfirmed
            }).show();
            Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                category : 'Organizer Responses',
                action : 'Push confirmation popup'
            });
        },

        sendMessageConfirmed : function() {
            var message = this.$('textarea').val();
            var thisView = this;

            Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                category : 'Organizer Responses',
                action : 'push sent'
            });

            // Be optimistic - Do not wait for server response and update UI
            Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                msg : "The announcement is being sent to your attendees",
                errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.SUCCESS,
                autoHide : true
            });
            var messagesLeft = thisView.model.get('aggregated-data-push-notifications-left') - 1;
            thisView.model.set('aggregated-data-push-notifications-left', messagesLeft);
            thisView.clearMessage();
            thisView.updateButtonState();
            thisView.updateStatusState();

            BZAPI.sendMessageToRSVP(this.model.id, message, null, function() {
                var messagesLeft = thisView.model.get('aggregated-data-push-notifications-left') + 1;
                thisView.model.set('aggregated-data-push-notifications-left', messagesLeft);
                thisView.updateButtonState();
                thisView.updateStatusState();
                Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                    msg : "The announcement could not be sent - Please try again later."
                });
                Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                    category : 'Organizer Responses',
                    action : 'Failed to send push'
                });
            });
        },

        updateButtonState : function() {
            this.$('a.sendMessageButton').toggleClass('disabled', !this.canSendMessage());
        },

        updateStatusState : function() {
            var messageStatus = '';
            var servicePlan = Global.modelPool.getServicePlan(this.model.id);
            var buyMoreText = '(<a href="/account/cart?' + servicePlan.upgradeUrlQuery() + '">Get more</a>)';
            var pushStatus = this.model.canSendPushNotifications();
            if (pushStatus == this.model.sendPushNotificationsStatus.Allowed) {
                var messagesLeft = this.model.get('aggregated-data-push-notifications-left');
                messageStatus = ((messagesLeft == 1) ? 'One announcement' : messagesLeft + ' announcements') + ' left ' + buyMoreText;
            } else if (pushStatus == this.model.sendPushNotificationsStatus.NoMessagesLeft) {
                messageStatus = 'No announcements left ' + buyMoreText;
            } else if (pushStatus == this.model.sendPushNotificationsStatus.NotLive) {
                messageStatus = 'Publish your event in order to send announcements';
            } else if (pushStatus == this.model.sendPushNotificationsStatus.NotEnoughAttendees) {
                var minAttendeesForPushNotifications = this.model.get('min-attendees-for-push') || 15;
                messageStatus = 'Will be unlocked after at least ' + minAttendeesForPushNotifications + ' people joined your event community.';
            }
            this.$('span.sendMessageStatus').html(messageStatus);
        },

        updateTextareaState : function() {
            if (this.model.canSendPushNotifications() == this.model.sendPushNotificationsStatus.Allowed) {
                this.$('textarea').removeAttr('disabled');
            } else {
                this.$('textarea').attr('disabled', 'disabled');
            }

            this.updateStatusState();
        },

        setCounter : function() {
            this.$("textarea").charCount({
                allowed : this.MAX_MESSAGE_LENGTH,
                warning : 0,
                el : this.$(".counter")
            });
        },

        tabClicked : function(e) {
            var types = {
                mobile : false,
                web : false,
                mail : false
            };

            var clickedType = $(e.target).attr('name');
            types[clickedType] = true;
            _.each(types, function(value, key) {
                this.$('.push-message-box-tab.' + key).toggleClass('selected', value);
                this.$('.push-messages-image.' + key).toggleClass('hide', !value);
            }, this);
        }

    });

    return PushMsgsBoxView;

});
